import React from "react";
import { Portal as ReactPortal } from "react-portal";

interface Props {
  children: React.ReactNode;
  onClose?: () => void;
  onOpen?: () => void;
}

const Portal = ({ children, onClose, onOpen }: Props) => {
  return (
    <ReactPortal
      node={document && document.getElementById("react-portal-container")}
    >
      {children}
    </ReactPortal>
  );
};

export default Portal;
